
import { call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { startExport, exportSuccess, exportFailure } from '../slices/exportSlice';
import { toast } from '@/hooks/use-toast';
import { exportCompetitorsDashboard, exportDashboard } from '@/api/products';

interface ExportParams {
  brand?: string;
  category?: string;
  search?: string;
  provider_ids?: string;
}

export const requestExport = createAction<{
  isCompetitor: boolean;
  params: ExportParams;
}>('export/requestExport');

function* handleExport(action: ReturnType<typeof requestExport>) {
  try {
    yield put(startExport());
    
    const { isCompetitor, params } = action.payload;
    const endpoint = isCompetitor ? exportDashboard : exportCompetitorsDashboard;
    yield call(endpoint, params);
    
    yield put(exportSuccess());
    toast({
      title: "Export Started",
      description: "Your export request has been processed successfully. You will receive an email when it's ready.",
    });
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Export failed';
    yield put(exportFailure(errorMessage));
    toast({
      variant: "destructive",
      title: "Export Failed",
      description: "There was an error processing your export request. Please try again.",
    });
  }
}

export function* exportSaga() {
  yield takeLatest(requestExport.type, handleExport);
}
